export default "__VITE_ASSET__BqkliRXv__"